/**
 * @module interface
 */
export interface V2TimFaceElem {
    index?: number;
    data?: string;
}
